const createFromFileSteps= [
    {
        content: <h2>Let's begin !</h2>,
        locale: { skip: <strong>SKIP</strong> },
        placement: "center",
        target: "body"
    },
    {
      content: <h2>In the first step of creating a survey, you need to enter the survey name in this field.</h2>,
      placement: "bottom",
      target: "#cffSurveyTitle",
      title: "First step"
    },
    {
      content: <h2>You can download example JSON or Excel templates from this section to assist you in the survey creation process.</h2>,
      placement: "bottom",
      target: "#cffTemplate",
      title: "Second step"
    },
    {
      content: <h2>In this section, you can upload the file containing your survey data to proceed with survey creation.</h2>,
      placement: "bottom",
      target: "#cffUploadFile",
      title: "Third step"
    },
  ]
  export default createFromFileSteps;